import type { RuleSet } from 'styled-components';

import styled, { css } from 'styled-components';

import { shimmerAnimation } from '../../shared/common/styles';
import { colors, media } from '../../shared/core/styles';
import { SiteType } from '~/utilities/graphql/codegen';

const GStarTileStyle = css``;

const AAFTileStyle = css`
  --product-tile-details-height: 51px;
`;

const TileStyles: Record<SiteType, RuleSet> = {
  [SiteType.Gstar]: GStarTileStyle,
  [SiteType.Wahts]: GStarTileStyle,
  [SiteType.Outlet]: GStarTileStyle,
  [SiteType.Employeeshop]: GStarTileStyle,
  [SiteType.Aaf]: AAFTileStyle,
};

const S = {
  SkeletonGridItem: styled.article`
    /* stylelint-disable declaration-property-value-no-unknown */

    @property --product-tile-details-height {
      syntax: '<length>';
      inherits: true;
      initial-value: 77px;
    }

    ${({ theme }) => TileStyles[theme.siteType]}

    /* tile size at screen width: 430px */
    padding-bottom: calc((350 / 203) * 100%);
    position: relative;

    &::after {
      position: absolute;
      bottom: 0;
      top: 0;
    }

    ${shimmerAnimation}

    height: 0;

    @media ${({ theme }) => media(theme).noHover} {
      --mobile-hard-stop-1: 87%;
      --mobile-hard-stop-2: 86.1%;
      --mobile-hard-stop-3: 74.9%;
      --mobile-hard-stop-4: 74%;
      --mobile-hard-stop-5: 67.9%;
      --mobile-hard-stop-6: 67%;

      background: linear-gradient(
        180deg,
        ${({ theme }) => theme.colors.neutral[200]} 0%,
        ${({ theme }) => theme.colors.neutral[200]} var(--mobile-hard-stop-6),
        ${colors.WHITE} var(--mobile-hard-stop-6),
        ${colors.WHITE} var(--mobile-hard-stop-5),
        ${({ theme }) => theme.colors.neutral[200]} var(--mobile-hard-stop-5),
        ${({ theme }) => theme.colors.neutral[200]} var(--mobile-hard-stop-4),
        ${colors.WHITE} var(--mobile-hard-stop-4),
        ${colors.WHITE} var(--mobile-hard-stop-3),
        ${({ theme }) => theme.colors.neutral[200]} var(--mobile-hard-stop-3),
        ${({ theme }) => theme.colors.neutral[200]} var(--mobile-hard-stop-2),
        ${colors.WHITE} var(--mobile-hard-stop-2),
        ${colors.WHITE} var(--mobile-hard-stop-1),
        ${({ theme }) => theme.colors.neutral[200]} var(--mobile-hard-stop-1),
        ${({ theme }) => theme.colors.neutral[200]} 100%
      );
    }

    @media ${({ theme }) => media(theme).canHover} {
      --desktop-hard-stop-1: 94%;
      --desktop-hard-stop-2: 93%;
      --desktop-hard-stop-3: 89%;
      --desktop-hard-stop-4: 87.5%;

      padding-bottom: calc(var(--product-tile-details-height) + ((4 / 3) * 100%));
      background: linear-gradient(
        180deg,
        ${({ theme }) => theme.colors.neutral[200]} 0%,
        ${({ theme }) => theme.colors.neutral[200]} var(--desktop-hard-stop-4),
        ${colors.WHITE} var(--desktop-hard-stop-4),
        ${colors.WHITE} var(--desktop-hard-stop-3),
        ${({ theme }) => theme.colors.neutral[200]} var(--desktop-hard-stop-3),
        ${({ theme }) => theme.colors.neutral[200]} var(--desktop-hard-stop-2),
        ${colors.WHITE} var(--desktop-hard-stop-2),
        ${colors.WHITE} var(--desktop-hard-stop-1),
        ${({ theme }) => theme.colors.neutral[200]} var(--desktop-hard-stop-1),
        ${({ theme }) => theme.colors.neutral[200]} 100%
      );
    }
  `,
};

export const SkeletonTile = () => <S.SkeletonGridItem data-testid="skeleton" />;
